// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VeeValidate from 'vee-validate'
import particles from 'particles.js'
import store from './store'
import '@/utils/vueFbCustomerChat'
import '@/utils/filters'
import '@/utils/mixins'
import '@/utils/bus'
import '@/icons'
import './styles/App.scss'
import i18n from './lang/index.js'

import {
  Select,
  Option,
  Table,
  Autocomplete,
  TableColumn,
  Loading,
  Tabs,
  TabPane,
  Pagination,
  Collapse,
  CollapseItem,
  Tooltip,
  Radio,
  RadioGroup,
  RadioButton,
  DatePicker,
  Progress,
  Dialog
} from 'element-ui'

import Spinner from '@/components/Spinner'

// Element UI components
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Autocomplete)
Vue.use(Loading)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Pagination)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Tooltip)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(DatePicker)
Vue.use(Progress)
Vue.use(Dialog)

Vue.component(Spinner.name, Spinner)

Vue.use(particles)

Vue.use(VeeValidate, {
  // 避免自動 inject 到所有 component
  inject: false,
  // 語系
  locale: 'zh_CN',
  // 驗證字串
  dictionary: {
    zh_TW: {
      messages: {
        required (type) {
          return type ? i18n.t('message.formColumnEmpty', {msg: i18n.t('account.' + type)}) : i18n.t('message.formColumnEmpty')
        }
      }
    },
    zh_CN: {
      messages: {
        required (type) {
          return type ? i18n.t('message.formColumnEmpty', {msg: i18n.t('account.' + type)}) : i18n.t('message.formColumnEmpty')
        }
      }
    }
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js